// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/jepx_member_info_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/jepx_member_info_model.proto.
 */
export const file_bffuser_v1_jepx_member_info_model: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZ1c2VyL3YxL2plcHhfbWVtYmVyX2luZm9fbW9kZWwucHJvdG8SCmJmZnVzZXIudjEioQEKDkplcHhNZW1iZXJJbmZvEhYKDmplcHhfbWVtYmVyX2lkGAEgASgJEhUKDWJ1c2luZXNzX2NvZGUYAiABKAkSFQoNYnVzaW5lc3NfbmFtZRgDIAEoCRIZChFvcmdhbml6YXRpb25fbmFtZRgEIAEoCRIuCgp1cGRhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKZAgoPSmVweEZlZVNjaGVkdWxlEjYKGHNwb3RfdHJhZGluZ19mZWVfcGVyX2t3aBgBIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWwSOgocaW50cmFkYXlfdHJhZGluZ19mZWVfcGVyX2t3aBgCIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWwSIQoZYW5udWFsX21lbWJlcnNoaXBfZmVlX3llbhgDIAEoAxIWCg5zb3VyY2VfdmVyc2lvbhgEIAEoCRInCgxwdWJsaXNoZWRfb24YBSABKAsyES5nb29nbGUudHlwZS5EYXRlEi4KCnVwZGF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * JepxMemberInfo mirrors internalapi.v1.JepxMemberInfo for the frontend:
 * the organization's JEPX 会員情報 (システム全体で 1 件)。 運営が登録し、
 * お客様向け画面は閲覧専用 (docs/specs/admin/integration/jepx-member-info.md)。
 *
 * @generated from message bffuser.v1.JepxMemberInfo
 */
export type JepxMemberInfo = Message<"bffuser.v1.JepxMemberInfo"> & {
  /**
   * JEPX 会員ID。
   *
   * @generated from field: string jepx_member_id = 1;
   */
  jepxMemberId: string;

  /**
   * 会員IDに紐づく OCCTO 事業者コード (4 桁)。
   *
   * @generated from field: string business_code = 2;
   */
  businessCode: string;

  /**
   * 広域マスタ (事業者マスタ) から解決した事業者名 (AC-IJM-004)。
   * 空文字は未解決 (frontend が「(未解決)」表示に落とす)。
   *
   * @generated from field: string business_name = 3;
   */
  businessName: string;

  /**
   * eAuth から解決した発注組織の名称 (AC-IJM-005)。 空文字は未解決。
   * 組織ID (内部識別子) は載せない。
   *
   * @generated from field: string organization_name = 4;
   */
  organizationName: string;

  /**
   * 会員情報の最終更新日時。
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.JepxMemberInfo.
 * Use `create(JepxMemberInfoSchema)` to create a new message.
 */
export const JepxMemberInfoSchema: GenMessage<JepxMemberInfo> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_member_info_model, 0);

/**
 * JepxFeeSchedule mirrors internalapi.v1.JepxFeeSchedule: JEPX 参加料規程に
 * 基づく料金・手数料 (閲覧専用、 AC-IJM-007 / AC-IJM-008)。
 *
 * @generated from message bffuser.v1.JepxFeeSchedule
 */
export type JepxFeeSchedule = Message<"bffuser.v1.JepxFeeSchedule"> & {
  /**
   * スポット市場 取引手数料 (円/kWh)。
   *
   * @generated from field: google.type.Decimal spot_trading_fee_per_kwh = 1;
   */
  spotTradingFeePerKwh?: Decimal;

  /**
   * 時間前市場 取引手数料 (円/kWh)。
   *
   * @generated from field: google.type.Decimal intraday_trading_fee_per_kwh = 2;
   */
  intradayTradingFeePerKwh?: Decimal;

  /**
   * 年会費 = 会員維持費 (円/年)。
   *
   * @generated from field: int64 annual_membership_fee_yen = 3;
   */
  annualMembershipFeeYen: bigint;

  /**
   * 出典 (JEPX 参加料規程のバージョン)。
   *
   * @generated from field: string source_version = 4;
   */
  sourceVersion: string;

  /**
   * 出典規程の反映日。
   *
   * @generated from field: google.type.Date published_on = 5;
   */
  publishedOn?: Date;

  /**
   * 料金・手数料の最終更新日時。
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.JepxFeeSchedule.
 * Use `create(JepxFeeScheduleSchema)` to create a new message.
 */
export const JepxFeeScheduleSchema: GenMessage<JepxFeeSchedule> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_member_info_model, 1);

